/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ReportScheduler {

    import SecurityParts = Meevo.Components.Common.SecurityParts;
    import IReportControl = Meevo.Model.IReportControl;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import IReportGeneralInfo = Meevo.Model.IReportGeneral;
    import PageStateEnum = Meevo.Model.PageStateEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class ReportSchedulerContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        showInputForm: boolean;
        selectedReport: IReportGeneralInfo = null;
        selectedCategory: IReportCategory;
        reportControls: Array<IReportControl>;
        reportAuditEntity: Guid;
        reportModel: Object = {};
        reportModelForSubmit: Object = {};
        reportUrl: string;
        hierarchyForm: ng.IFormController;
        validationJson: any = {};
        showMenuType: PageStateEnum;
        startDayOfWeek?: Number;
        runPermission: SecurityAccessEnum = SecurityAccessEnum.Hide;
        isBackArrowVisible: boolean;
        days: Array<number>;
        daysRef: any;
        frequencyUnitReferenceData: any;
        selectedDaysList: string;
        selectedWeekOccurrence: any;
        employeeCount: number;
        employeeList: any;
        userCount: number;
        userList: any;
        savingInProgress: boolean;

        public reportParameterDateRangeEnum: any;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $scope: ng.IScope,
                    protected $sce: angular.ISCEService,
                    protected $q: angular.IQService,
                    protected reportsHelper: IReportsHelper,
                    protected $translate: angular.translate.ITranslateService,
                    protected $rootScope: ng.IRootScopeService,
                    public reportCategories: Array<IReportCategory>,
                    public reportList: Array<IReportGeneralInfo>
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityService, trackingService, null, false);
            this.sectionTemplatePath = 'app/plugins/reportScheduler/sectionViews/';
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.reportScheduler;
            this.initializeSections();
            this.buildCrudSecurityKeys(this.securityKeys.MANAGEMENT_REPORTSCHEDULE_TAB_MAIN);
            this.showMenuType = PageStateEnum.ReportList;
            this.startDayOfWeek = this.$rootScope.appointmentBookSettings.startAppointmentBookDayOn;

            this.reportCategories.forEach((category) => {
                // Remove Core Royalty from start screen
                category.reports = category.reports.filter(report => report.id !== 224);

                // Check for translations and assign if applicable
                category.reports = this.applyReportTranslations(category.reports);
            });

            if (this.reportCategories && this.reportCategories.length >= 1) {
                this.selectedCategory = this.reportCategories[0];
            }
            this.showMenuType = PageStateEnum.ReportList;
            this.initializeData();
        }

        /**
         * Check for name and description translations and apply to report
         */
        applyReportTranslations(reports: IReportGeneralInfo[]): IReportGeneralInfo[] {
            return reports.map((report) => this.applyTranslationToReport(report));
        }

        applyTranslationToReport(report: IReportGeneralInfo): IReportGeneralInfo {
            var translatedDisplayName = this.$translate.instant(`LABEL_${report.shortCut.toUpperCase()}_DISPLAY_NAME`); 
            if (translatedDisplayName && translatedDisplayName.indexOf('LABEL_') === -1) {
                report.displayName = translatedDisplayName;
            }
            var translatedDescription = this.$translate.instant(`LABEL_${report.shortCut.toUpperCase()}_DESCRIPTION`);
            if (translatedDescription && translatedDescription.indexOf('LABEL_') === -1) {
                report.description = translatedDescription;
            }
            return report;
        }

        initializeData(): void {
            this.savingInProgress = false;

            this.reportParameterDateRangeEnum = {
                Today: 11039759,
                Yesterday: 11039760,
                ThisWeek: 11039761,
                LastWeek: 11039762,
                LastSevenDays: 11039763,
                PreviousTwoWeeks: 11039764,
                ThisMonth: 11039765,
                LastMonth: 11039766,
                ThisQuarter: 11039767,
                LastQuarter: 11039768,
                NextQuarter: 11039769,
                ThisYear: 11039770,
                LastYear: 11039771,
                Tomorrow: 11039772,
                NextWeek: 11039773,
                NextMonth: 11039774,
                NextYear: 11039775,
                LastTwelveMonths: 11039776,
                LastThirteenMonths: 11045772,
            }
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_REPORTSCHEDULE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(0,
                    'SECTION_MAIN',
                    'main.html',
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.reportScheduler,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ReportSchedulerMain,
                    this.appSettings,
                    this.securityKeys.MANAGEMENT_REPORTSCHEDULE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.$translate,
                    this.modalService,
                    this.$scope,
                    this)
                );
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        /**
         * Add New item
         */
        add(preventUsageTracking: boolean = false): void {
            
            this.initializeForAdd(this.sections[0]);
            this.headerContent = "";
            this.selectedReport = null;
            this.showMenuType = PageStateEnum.ReportList;
            this.selectedSection["selectDifferentReport"]();
            if (preventUsageTracking) return;
            this.usageTrackingLog(Model.VerbEnum.AddNewButtonClicked, null);

            
        }

        loadReportInputTemplate(report: IReportGeneralInfo, showBusy: boolean = true, reportContext?: any): ng.IPromise<any> {

            if (report.permission === SecurityAccessEnum.Deny) {
                this.modalService.warning('LABEL_REPORT_ACCESS_DENIED', Components.Modal.ModalTranslationModes.Translate);

                return this.$q.resolve();
            }

            this.showInputForm = true;
            // Apply translations to report and assign to selectedReport
            this.selectedReport = this.applyTranslationToReport(report);
            this.reportModel = {};
            this.reportModelForSubmit = {};
            this.runPermission = report.permission;
            this.selectedSection.model["reportId"] = report.id;
            if (showBusy) {
                this.busyService.start();
            }

            if (this.selectedSection.sectionId == 0 && report && report.id) {
                (<MainSection>this.selectedSection).updateFileFormatFilters(report.id.toString());
            }

            if (reportContext) {
                this.reportControls = <Array<IReportControl>>reportContext.controls;
                
                this.hideCustomDateTimeReportControls();

                this.reportAuditEntity = <Guid>reportContext.reportAuditEntity;
                this.showMenuType = PageStateEnum.Controls;
                this.isBackArrowVisible = this.checkPageStatus();
                if (reportContext.validationJSON) {
                    this.loadValidationJson(reportContext);
                } else {
                    this.validationJson = {};
                }
                if (showBusy) {
                    this.busyService.stop();
                }

                return this.$q.resolve();
            } else {

                var scope = this;
                return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/report/report/${report.id}`, 'GET', {})
                    .then((result: ng.IHttpResponseTransformer | any) => {
                        this.reportControls = <Array<IReportControl>>result.data.controls;

                        this.hideCustomDateTimeReportControls();

                        // MA050: when saved, override dropdown control default value ("Business" - assigned in reportControl.directive.ts) with selected value. (VSTS 27011)
                        if (scope.selectedSection.model["reportId"] === 63 && scope.selectedSection.model["reportParameterJSON"]) {
                            var reportParameterJSONDeserialized = JSON.parse(scope.selectedSection.model["reportParameterJSON"]);

                            var dropDownControl: any = _.findWhere(this.reportControls, { id: 204 });
                            if (dropDownControl && reportParameterJSONDeserialized
                                && reportParameterJSONDeserialized['ClientVisitsDefinedAsNewToMA050']) {
                                scope.reportControls[dropDownControl.sequence - 1].parameters[0]["default"] = { value: reportParameterJSONDeserialized['ClientVisitsDefinedAsNewToMA050'] };
                            }
                        }

                        // AQ225: override AppointmentCategory param to load user saved selection (BUG 43224).
                        // Note: AppointmentCategory's control; AppointmentCategoryTypeAhead yields an 'object' upon selecting an option. 
                        // Therefore, we need to reconstruct this 'object' from its corresponding saved 'id' and 'displayName' properties.
                        if (scope.selectedSection.model["reportId"] === 78 && scope.selectedSection.model["reportParameterJSON"]) {
                            var reportParameterJSONDeserialized = JSON.parse(scope.selectedSection.model["reportParameterJSON"]);

                            reportParameterJSONDeserialized["AppointmentCategory"] = { id: reportParameterJSONDeserialized["AppointmentCategory"], displayName: reportParameterJSONDeserialized["AppointmentCategoryDisplayName"] };
                            scope.selectedSection.model["reportParamJson"] = reportParameterJSONDeserialized;
                        }
                            
                        this.reportAuditEntity = <Guid>result.data.reportAuditEntity;
                        this.showMenuType = PageStateEnum.Controls;
                        this.isBackArrowVisible = this.checkPageStatus();
                        if (result.data.validationJSON) {
                            this.loadValidationJson(result.data);
                        } else {
                            this.validationJson = {};
                        }
                        if (showBusy) {
                            this.busyService.stop();
                        }

                    });
            }
        }

        loadValidationJson(response: any): void {
            this.validationJson = JSON.parse(response.validationJSON);
            if (this.validationJson.DateBack) {
                this.validationJson.DateBack = {
                    from: moment(new Date()).subtract(this.validationJson.DateBack[0], 'd').toDate(),
                    to: moment(new Date()).subtract(this.validationJson.DateBack[1], 'd').toDate()
                };
            }
            if (this.validationJson.MaxDateCalendar) {
                this.validationJson.MaxDateCalendar = moment(new Date()).subtract(this.validationJson.MaxDateCalendar, 'd').toDate();
            }
            if (this.validationJson.MinDateCalendar) {
                this.validationJson.MinDateCalendar = moment(new Date()).add(this.validationJson.MinDateCalendar, 'd').toDate();
            }
            if (this.validationJson.ShowIfChecked) {
                Object.keys(this.validationJson.ShowIfChecked).forEach((key) => {
                    if (typeof this.validationJson.ShowIfChecked[key] === 'string') {
                        this.validationJson.ShowIfChecked[key] = [this.validationJson.ShowIfChecked[key]];
                    }
                });
            }
        }

        /**
         * Check current/target permission
         * @param type - permission type
         * @param targetPermission - check target
         * @returns result
         * */
        checkSecurityKey(type: string = 'Grant', targetPermission?: any): boolean {
            let target = targetPermission ? targetPermission : this.runPermission;

            return target === SecurityAccessEnum[type];
        }

        checkPageStatus(): boolean {
            return this.showMenuType !== PageStateEnum.CategoryList && this.showMenuType !== PageStateEnum.ReportList;
        }

        hideCustomDateTimeReportControls(): void {
            for (var i = 0; i < this.reportControls.length; i++) {
                if (this.reportControls[i].displayName.toLowerCase().indexOf("openclosehistorydatetime") != -1) {
                    this.reportControls[i]["hideOpenCloseHistoryDateTime"] = "true";
                    this.reportControls[i]["hideOpenCloseHistoryStartTime"] = true;
                    this.reportControls[i]["hideOpenCloseHistoryEndTime"] = true;
                    this.reportControls[i]["hideFullDayButton"] = true;
                }

                if (this.reportControls[i].displayName.toLowerCase().indexOf("datetime") != -1
                    || this.reportControls[i].displayName.toLowerCase().indexOf("daterange") != -1) {
                    this.reportControls[i]["hideDatePickers"] = "true";
                    this.reportControls[i]["hideLongDateRanges"] = "true";
                }

                

                for (var j = 0; j < this.reportControls[i].parameters.length; j++) {
                    if (this.reportControls[i].parameters[j].name.toLowerCase().indexOf("startdate") != -1
                        || this.reportControls[i].parameters[j].name.toLowerCase().indexOf("enddate") != -1) {
                        this.reportControls[i]["hideDatePickers"] = "true";
                        this.reportControls[i]["hideLongDateRanges"] = "true";
                    }
                }
            }

        }

        /**
         * Do manipulations with a model before submitting the form.
         */
        preSubmit(): void {
            // User Story 39526: Report Controls for AQ030 (Booking Traffic)
            // BookingTrafficType: DayofWeek, EmployeeSummary, TimeofDay
            //if (this.context.reportControls.length === 1 && this.context.reportControls[0].displayName === 'BookingTraffic') {
            //    let parameterNames = this.context.reportControls[0].parameters.map((p) => p.name);

            //    if (this.context.reportModelForSubmit[parameterNames[0]] === 'DayofWeek' || this.context.reportModelForSubmit[parameterNames[0]] === 'TimeofDay') {
            //        this.context.reportModelForSubmit[parameterNames[5]] = []; // BookingTrafficEmployeeCategoryList_TBL
            //        this.context.reportModelForSubmit[parameterNames[6]] = []; // BookingTrafficEmployeeList_TBL
            //    }

            //    if (this.context.reportModelForSubmit[parameterNames[0]] === 'DayofWeek') {
            //        // BookingTrafficStartTime = BookingTrafficStartDate
            //        this.context.reportModelForSubmit[parameterNames[3]] = this.context.reportModel[parameterNames[1]];

            //        // BookingTrafficEndTime = BookingTrafficEndDate
            //        this.context.reportModelForSubmit[parameterNames[4]] = this.context.reportModel[parameterNames[2]];
            //    }
            //}

            // User Story 41834:Report Control behavior for DR020 (local)
            if (this.selectedSection.model["reportId"] == 34 && this.selectedSection.model["reportParamJson"]['viewReportBy'] === 'SummaryView') { // 'DR020'
                // set default values to fields which are hidden
                this.selectedSection.model["reportParamJson"]['displayPhoneNumber'] = false;
                this.selectedSection.model["reportParamJson"]['FieldOrderBy'] = 'ReferralType';
            }

            // Report Controls for MI105 (local)
            //if (this.context.selectedReport.shortCut === 'MI105' && this.context.reportModelForSubmit['viewInventoryReportBy'] === 'Main') {
            //    this.context.reportModelForSubmit['ReturnHeaderIdList_TBL'] = [];
            //}

            // Report Controls for MI025 (local)
            //if (this.context.selectedReport.shortCut === 'MI025') {
            //    switch (this.context.reportModelForSubmit['SortReportBy']) {
            //        case 'FloorLocation':
            //            this.context.reportModelForSubmit['Manufacturers_TBL'] = [];
            //            this.context.reportModelForSubmit['ProductCats_TBL'] = [];
            //            break
            //        case 'Manufacturer':
            //            this.context.reportModelForSubmit['ProductCats_TBL'] = [];
            //            this.context.reportModelForSubmit['FloorLocations_TBL'] = [];
            //            break
            //        case 'ProductCategory':
            //            this.context.reportModelForSubmit['Manufacturers_TBL'] = [];
            //            this.context.reportModelForSubmit['FloorLocations_TBL'] = [];
            //            break
            //    }
            //}

            // Report Controls for MI105 (local)
            //if (this.context.selectedReport.shortCut === 'DP005') {
            //    if (!this.context.reportModelForSubmit['SpecificNumber']) {
            //        delete this.context.reportModelForSubmit['NumberOfLabels'];
            //    }
            //    if (this.context.reportModelForSubmit['ProductListWithLabelCounts_TBL'].length) {
            //        this.context.reportModelForSubmit['ProductListWithLabelCounts_TBL'].forEach((item) => {
            //            item['labelCount'] = item.numberOfLabels;
            //            delete item.barCode;
            //            delete item.generalDisplayName;
            //            delete item.numberOfLabels;
            //            delete item.selected;
            //        });
            //    }
            //}

            //if (['DE040', 'DE044'].indexOf(this.context.selectedReport.shortCut) !== -1) {
            //    this.context.reportModelForSubmit['PayPeriodEmployeeCategories_TBL'] = [];
            //}

            if (this.selectedSection.model["reportId"] == 1) { // 'AQ020'
                this.selectedSection.model["reportParamJson"]['NoOfClientVisitNotes'] = 8;
                this.selectedSection.model["reportParamJson"]['NoOfServiceHistory'] = 24;
                this.selectedSection.model["reportParamJson"]['NoOfRetailHistory'] = 24;
                this.selectedSection.model["reportParamJson"]['NoOfTodaysAppointments'] = 15;
                this.selectedSection.model["reportParamJson"]['NoOfFutureAppointments'] = 5;
            } else if (this.selectedSection.model["reportId"] == 2) { // 'AQ022'
                this.selectedSection.model["reportParamJson"]['NoOfClientVisitNotes'] = 3;
                this.selectedSection.model["reportParamJson"]['NoOfServiceHistory'] = 5;
                this.selectedSection.model["reportParamJson"]['NoOfRetailHistory'] = 5;
                this.selectedSection.model["reportParamJson"]['NoOfTodaysAppointments'] = 10;
                this.selectedSection.model["reportParamJson"]['NoOfFutureAppointments'] = 3;
            }

            //if (this.context.selectedReport.shortCut === 'MR130') {
            //    if (typeof this.selectedSection.model["reportParamJson"]['SaleDate'] === 'number') {
            //        this.selectedSection.model["reportParamJson"]['SaleDate'] = new Date(this.selectedSection.model["reportParamJson"]['SaleDate'], 0);
            //    }
            //}

            // AQ225: override AppointmentCategory param to avoid data type conversion issue (BUG 43224).
            // Note: AppointmentCategory's control; AppointmentCategoryTypeAhead yields an 'object' upon selecting an option. 
            // Whereas, at DB level, this control expects a unique identifier value 'id' for its corresponding input param.
            if (this.selectedSection.model["reportId"] === 78) {
                if (this.selectedSection.model["reportParamJson"]['AppointmentCategory']) {
                    this.selectedSection.model["reportParamJson"]['AppointmentCategoryDisplayName'] = this.selectedSection.model["reportParamJson"]['AppointmentCategory'].displayName;
                    this.selectedSection.model["reportParamJson"]['AppointmentCategory'] = this.selectedSection.model["reportParamJson"]['AppointmentCategory'].id;

                }
                else {
                    this.selectedSection.model["reportParamJson"]['AppointmentCategory'] = null;
                    this.selectedSection.model["reportParamJson"]['AppointmentCategoryDisplayName'] = null;
                }
            }

            if (this.selectedSection.model["reportParamJson"]['categories']) {
                delete this.selectedSection.model["reportParamJson"]['categories'];
            }

            //DC080
            if (this.selectedSection.model['reportId'] === 220) {
                this.selectedSection.model["reportParamJson"]['hideSelectedClientAmount'] = true;
            }
            //DC080

            if (!this.selectedSection.model["reportParamJson"].hasOwnProperty('clientSortOrderEnum')) {
                // return sort order for use in the trdx
                this.selectedSection.model["reportParamJson"]['clientSortOrderEnum'] = this.appSettings.APP_BUSINFOSETTINGS.clientsSettings.defaultClientSortOrder;
            }

            // Check for name translation and add to report parameters if applicable
            var translatedDisplayName = this.$translate.instant(`LABEL_${this.selectedReport.shortCut.toUpperCase()}_DISPLAY_NAME`);
            if (translatedDisplayName && translatedDisplayName.indexOf('LABEL_') === -1) {
                this.selectedSection.model['reportParamJson']['displayName'] = translatedDisplayName;
            }
        }


        save(): angular.IPromise<any> {

            if (this.selectedSection.model["userRecipientList"].length == 0 && this.selectedSection.model["employeeRecipientList"].length == 0 && this.selectedSection.model["customUserRecipientList"].length == 0) {
                this.modalService.alert("MESSAGE_SCHEDULE_NEEDS_AT_LEAST_ONE_RECIPIENT");
                return;
            }

            if (this.selectedSection.model.objectState == ObjectStateEnum.Inactive && this.selectedSection["backup"].objectState == ObjectStateEnum.Active) {
                this.modalService.alert("MESSAGE_REPORT_WILL_NO_LONGER_BE_SENT_OUT");
            }

            let addingMode = this.mode === Meevo.Model.MaintenanceFormState.Adding,
                copyingMode = this.mode === Meevo.Model.MaintenanceFormState.Copying;

            if (this.canSave && !this.savingInProgress) {

                this.preSubmit();
                this.selectedSection.preSave();
                this.loadingInProgress = true;
                this.savingInProgress = true;

                //don't use finally on the promises below. this should be skipped if there is a warning
                //postAdd dismisses the data maint form.
                let finallyFcn = () => {
                    this.savingInProgress = false;
                    this.loadingInProgress = false;
                    this.updateCoBarData(this.selectedSection.model);

                    if (this.customDataContextConfig && this.customDataContextConfig.use) {
                        if ((addingMode || copyingMode) && this.selectedSection.customControlsModel) {
                            // if entity didn't have id (wasn't created or copied yet)

                            this.selectedSection.customControlsModel.answers.map(answer => {
                                answer.entity_Id = this.selectedSection.model.id;

                                return answer;
                            });
                        }

                        this.selectedSection.saveCustomControls();
                    }
                };
                this.usageTrackingLog(Meevo.Model.VerbEnum.SaveButtonClicked, null);

                if (this.mode === Meevo.Model.MaintenanceFormState.Adding || this.mode === Meevo.Model.MaintenanceFormState.Copying) {
                    if (this.identityService.inCentralOfficeMode()) {
                        if (this.identityService.userBusinessTypes.length == 1)
                            this.selectedSection.model.businessTypeDetail = this.identityService.userBusinessTypes[0];
                    }

                    var finalModel = angular.copy(this.selectedSection.model);
                    finalModel["reportName"] = this.selectedReport.shortCut; // Needed for audit
                    finalModel["ReportParameterJSON"] = angular.toJson(this.selectedSection.model["reportParamJson"]);
                    if (this.selectedSection.model["reportParamJson"] != null && this.selectedSection.model["reportParamJson"].selectedPreset != null) {
                        var enumValue = this.getDateRangeEnumValue(this.selectedSection.model["reportParamJson"].selectedPreset.status);
                        finalModel["reportParameterDateRangeEnum"] = enumValue;
                    }

                    return this.dataService.add(this.baseEndpoint, finalModel, this.itemId, this.selectedSection.sectionEndpoint)
                        .then((data: any) => {
                            if (data.isWarning) {
                                this.handleWarnings(data.responseStatus.errors);
                            } else {
                                this.itemId = data.id;
                                for (let i = 0; i < this.sections.length; i++) {
                                    this.sections[i].setParentItemId(this.itemId);
                                }
                                this.selectedSection.model = data;
                                this.businessTypeDetail = data.businessTypeDetail;
                                this.selectedSection.sectionModelRetrieved();
                                this.setMode(Model.MaintenanceFormState.Readonly);
                                this.loggingService.trace(`New item saved.`);
                                this.postAdd(this.selectedSection.model);
                                finallyFcn();
                            }
                        })
                        .catch((reason: any) => {
                            this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                            this.savingInProgress = false;
                            this.loadingInProgress = false;
                        });
                    // Handling location override
                }
                else {
                    // For overrides pass as location override contract
                    //if (this._takeOwnership) {
                    //    this.selectedSection.model.locationId = this.identityService.current().centralOfficeId;
                    //    this.selectedSection.model.homeLocationId = this.identityService.current().centralOfficeId;
                    //    this.selectedSection.model.availableToLocations = true;
                    //    if (this.identityService.inCentralOfficeMode()) {
                    //        if (this.identityService.userBusinessTypes.length == 1) {
                    //            this.selectedSection.model.businessTypeDetail = this.identityService.userBusinessTypes[0];
                    //        }
                    //    }
                    //}
                    var updateModel = this.isApplicationModeCO() ? <Model.IHasLocationOverride>this.selectedSection.model : this.selectedSection.model;
                    if (this.allowsCentralOfficeOptions) {
                        this.buildOverrideFieldList();
                    }

                    var finalUpdatedModel = angular.copy(updateModel);
                    finalUpdatedModel["ReportParameterJSON"] = angular.toJson(this.selectedSection.model["reportParamJson"]);

                    if (this.selectedSection.model["reportParamJson"] != null && this.selectedSection.model["reportParamJson"].selectedPreset != null) {
                        var enumValue = this.getDateRangeEnumValue(this.selectedSection.model["reportParamJson"].selectedPreset.status);
                        finalUpdatedModel["reportParameterDateRangeEnum"] = enumValue;
                    }

                    return this.dataService.update(this.baseEndpoint, finalUpdatedModel, this.itemId, this.selectedSection.sectionEndpoint, this.asLocationId)
                        .then((data: any) => {
                            if (data.isWarning) {
                                this.handleWarnings(data.responseStatus.errors);
                            } else {
                                this.selectedSection.model = data;
                                this.selectedSection.sectionModelRetrieved();
                                this.setMode(Model.MaintenanceFormState.Readonly);
                                this.loggingService.trace(`Updates saved.`);
                                this.postUpdate(this.selectedSection.model);
                                finallyFcn();
                            }
                        })
                        .catch((reason: any) => {
                            this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                            //finallyFcn();
                            this.savingInProgress = false;
                            this.loadingInProgress = false;
                        });
                }
            }
        }

        getDateRangeEnumValue = (enumValue: number): number => {
            var dateRangeEnumValue = 0;

            if (enumValue == Meevo.Components.Controls.PresetStatus.Custom)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.Custom;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.Today)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.Today;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.Yesterday)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.Yesterday;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.ThisWeek)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.ThisWeek;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.LastWeek)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.LastWeek;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.LastSevenDays)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.LastSevenDays;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.PreviousTwoWeeks)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.PreviousTwoWeeks;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.ThisMonth)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.ThisMonth;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.LastMonth)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.LastMonth;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.ThisQuarter)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.ThisQuarter;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.LastQuarter)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.LastQuarter;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.NextQuarter)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.NextQuarter;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.ThisYear)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.ThisYear;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.LastYear)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.LastYear;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.Tomorrow)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.Tomorrow;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.NextWeek)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.NextWeek;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.NextMonth)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.NextMonth;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.NextYear)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.NextYear;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.LastTwelveMonths)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.LastTwelveMonths;
            else if (enumValue == Meevo.Components.Controls.PresetStatus.LastThirteenMonths)
                dateRangeEnumValue = this.reportParameterDateRangeEnum.LastThirteenMonths;

            return dateRangeEnumValue;
        }

        loadReportUI(report: IReportGeneralInfo, showBusy: boolean = true, reportContext?: any, getReportInfo: boolean = false): void {
            if (getReportInfo) {
                var showBusySign = true;
                this.busyService.start();
                this.getReportInfo(report.id).then((result: Array<IReportGeneralInfo> | any) => {
                    let reports: Array<IReportGeneralInfo> = result;

                    for (var i = 0; i < reports.length; i++) {
                        if (reports[i].id == report.id) {
                            this.securityService.checkSecurityKey(reports[i].securityKey).then((permission: SecurityAccessEnum) => {
                                reports[i].permission = permission;
                            });
                            report = reports[i];
                            break;
                        }
                    }

                    this.loadReportInputTemplate(report, true, null).then(() => {
                        if (showBusySign) {
                            this.busyService.stop();
                            showBusySign = false;
                        }
                    }).finally(() => {
                        reportContext.showMenuType = PageStateEnum.Controls;
                        reportContext.isLoading = false;
                    });
                });
            }
        }

        getReportInfo(reportId): angular.IPromise<any> {
            var showBusySign = this.busyService.start();
            var report: IReportGeneralInfo;

            return this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.report, {
                criteria: {
                    categoryIds: [1, 2, 3, 6, 7, 8, 9, 10, 12, 15, 16, 17, 18],
                    objectStateEnum: ObjectStateEnum.Active
                    
                },
                asLocationId: this.$scope.reportScheduler != null ? this.$scope.reportScheduler.asLocationId : null
            });
        }

        get canUndelete(): boolean {
            return false;
        }

        get showUndelete(): boolean {
            return false;
        }

        /**
         * Deletes the selected item.
         */
        delete(): void {
            let vm = this;
            // Do not allow CO-owned items to be deleted in a location
            if (vm.isCoItemInLocation || vm.isLocationImpersonating) {
                vm.modalService.alert("MESSAGE_CANNOT_DELETE_CO_ITEM", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            if (this.canDelete) {
                this.modalService.warning("MESSAGE_DELETE_REPORT_SCHEDULE", 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then(() => {
                        vm.loadingInProgress = true;
                        // Patch model object state to deleted
                        vm.dataService.objectStatePatch(vm.baseEndpoint,
                            vm.itemId,
                            vm.selectedSection.model.entityVersion,
                            <number>Model.ObjectStateEnum.Deleted,
                            vm.asLocationId,
                            this.selectedSection.sectionEndpoint)
                            .then((data) => {
                                if (data) {
                                    vm.selectedSection.model = data;
                                    vm.selectedSection.sectionModelRetrieved();
                                    vm.loggingService.trace(`Delete saved.`);
                                }
                                this.postDelete();
                            })
                            .finally(() => {
                                vm.loadingInProgress = false;
                            });
                    });

            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
            this.usageTrackingLog(Meevo.Model.VerbEnum.DeleteButtonClicked, null);
        }

        cancel(): void {
            super.cancel();
        }
        postCancel() {
            super.postCancel();

            this.showMenuType = PageStateEnum.ReportList;
        }

        initializeForAdd(item: Meevo.Components.BaseClasses.IDataMaintenanceSection<Model.DataMaintenance>): void {
            super.initializeForAdd(item);
            this.showMenuType = PageStateEnum.ReportList;
        }

        unselectReportAndChangeMenu(): void {
            this.showMenuType = PageStateEnum.ReportList;
            this.selectedReport = null;
        }
    }
}
